// import AOS from 'aos';
// import gsap from 'gsap';
// import SmoothScroll from 'smoothscroll-for-websites';
// import smoothscroll from 'smoothscroll-polyfill';
import Alert from './alert';
import BrandModel from './brandModel';
import Filters from './filters';
import GaEvents from './gaevents';

import FormConfig from './formConfig';


window.onload = () => {
    // smoothscroll.polyfill();
    // SmoothScroll({
    //     stepSize: 80,
    //     accelerationMax: 10,
    //     animationTime: 1000,
    // });

    const bm = new BrandModel(); // eslint-disable-line
    const filters = new Filters(); // eslint-disable-line
    const alc = new Alert('.alert_classic', '.alert__trigger', '.alert__trigger_filter', 'add_alert'); // eslint-disable-line
    const als = new Alert('.alert_search', '.alertsearch__trigger', '', 'add_alert_search'); // eslint-disable-line
    const form = new FormConfig(); // eslint-disable-line
    const gaev = new GaEvents(); // eslint-disable-line

    // setTimeout(() => {
    //     // AOS.init({
    //     //     once: true,
    //     // });
    // }, 1001);
};
